// extracted by mini-css-extract-plugin
export default {"statisticItem":"DetailedItem_statisticItem__WpA1u","horizontal":"DetailedItem_horizontal__ae5ah","noOverflow":"DetailedItem_noOverflow__C4BgQ"};